module.exports = __webpack_public_path__ + "static/img/screen-5-es.dd6fc53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/screen-5-es.png
// module id = 5hML
// module chunks = 0